import React from "react";

function formatDate(dateString) {
  if (!dateString) return { month: "-", day: "-", year: "-" };
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return { month: "-", day: "-", year: "-" };
  return {
    month: String(date.getMonth() + 1).padStart(2, "0"),
    day: String(date.getDate()).padStart(2, "0"),
    year: date.getFullYear(),
  };
}

function getEmployeeId(employee, users) {
  if (!employee || !employee.id) return "-";
  const user = users.find(
    (user) => user.employee && user.employee.id === employee.id
  );
  return user && user.employeeId ? user.employeeId : "-";
}

const EmployeeTable = ({ employees, users }) => (
  <div className="table-responsive custom-scrollbar">
    <table className="table table-hover table-bordered">
      <thead className="table-light">
        <tr>
          <th rowSpan="2" className="align-middle">
            No.
          </th>
          <th rowSpan="2" className="align-middle">
            Emp. ID
          </th>
          <th colSpan="3" className="text-center">
            Employee Full Name
          </th>
          <th rowSpan="2" className="align-middle">
            Gender
          </th>
          <th rowSpan="2" className="align-middle">
            Contact #
          </th>
          <th colSpan="3" className="text-center">
            Birth Date
          </th>
          <th colSpan="1" className="text-center">
            Designation Based on Contract
          </th>
          <th rowSpan="2" className="align-middle">
            Employment Status
          </th>
          <th colSpan="1" className="text-center">
            Based on Contract
          </th>
          <th colSpan="4" className="text-center">
            GOV'T Remittances
          </th>
        </tr>
        <tr>
          <th>Last Name</th>
          <th>First Name</th>
          <th>Middle Name</th>
          <th>MM</th>
          <th>DD</th>
          <th>YYYY</th>
          <th>Position</th>
          <th>Date Start</th>
          <th>SSS Number</th>
          <th>Philhealth Number</th>
          <th>Pagibig Number</th>
          <th>TIN Number</th>
        </tr>
      </thead>
      <tbody>
        {employees.map((employee, index) => {
          const birthDate = formatDate(employee.birthDate);
          const startDate = formatDate(employee.startDate);
          const employeeId = getEmployeeId(employee, users);

          return (
            <tr key={employee.id} className="employee-row cursor-pointer">
              <td className="fw-bold">{index + 1}</td>
              <td>{employeeId}</td>
              <td>{employee.lastName || "-"}</td>
              <td>{employee.firstName || "-"}</td>
              <td>{employee.middleName || "-"}</td>
              <td>{employee.sex || "-"}</td>
              <td>{employee.mobileNumber || "-"}</td>
              <td>{birthDate.month}</td>
              <td>{birthDate.day}</td>
              <td>{birthDate.year}</td>
              <td>{employee.position || "-"}</td>
              <td>{employee.status || "Active"}</td>
              <td>
                {startDate.month + "/" + startDate.day + "/" + startDate.year}
              </td>
              <td>{employee.sss || "-"}</td>
              <td>{employee.philHealth || "-"}</td>
              <td>{employee.pagIbig || "-"}</td>
              <td>{employee.tin || "-"}</td>
            </tr>
          );
        })}
        {employees.length === 0 && (
          <tr>
            <td colSpan="19" className="text-center py-4">
              No employee records found
            </td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
);

export default EmployeeTable;
